<template>
    <a :href="href" class="news-file" target="_blank">
        <div>
            <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M17.5001 5.8335H40.8334L58.3334 23.3335V58.3335C58.3334 61.5418 55.7084 64.1668 52.5001 64.1668H17.4709C14.2626 64.1668 11.6667 61.5418 11.6667 58.3335V11.6668C11.6667 8.4585 14.2917 5.8335 17.5001 5.8335ZM23.3334 52.5002H46.6667V46.6668H23.3334V52.5002ZM46.6667 40.8335H23.3334V35.0002H46.6667V40.8335ZM37.9167 10.2085V26.2502H53.9584L37.9167 10.2085Z" fill="#3B66D3"/>
            </svg>
        </div>
        <div class="news-file-info">
            <div class="news-file-name">{{ name }}</div>
        </div>
    </a>
</template>
<script>


export default{
    name: 'NewsFile',
    props: {
        name: String,
        href: String
    }
}
</script>